import React, { FC, memo } from 'react'

import { TNeedHelp } from 'contexts/app-context/types/app-context/components/need-help'
import { PageContent } from 'common'

import { Text } from '@interco/inter-ui/components/Text'
import { uuid } from '@interco/inter-ui'

import { ConstactsContainer, ContactContainer } from '../styles/HelpCenter.styles'

export const HelpCenterView: FC<{
  content: TNeedHelp
}> = memo(({ content }) => {
  const { contacts } = content
  return (
    <PageContent>
      <ConstactsContainer>
        {contacts?.map(({ title, contact, subTitle }) => (
          <ContactContainer key={uuid()}>
            <Text variant="body-2" color="typography" colorWeight={500} bold>
              {title}
            </Text>
            <Text variant="body-3" color="typography" colorWeight={400} semiBold>
              {subTitle}
            </Text>
            <Text variant="body-3" color="primary" colorWeight={500} semiBold>
              {contact}
            </Text>
          </ContactContainer>
        ))}
      </ConstactsContainer>
    </PageContent>
  )
})
